module.exports = __webpack_public_path__ + "static/media/points-icon.2f76fa63.svg";